import { RootState } from '../../../../stories/store';
import { YourFinanceResponse } from '../yourFinance/yourFinanceTypes';
import { BorrowingPowerData } from './borrowingPowerTypes';

export const selectBorrowingPower = (state: RootState): BorrowingPowerData => state.borrowingPower.data;

export const selectBorrowingFinanceData = (state: RootState): YourFinanceResponse => (
    state.borrowingPower.financeData
);
